import { onMounted } from 'vue'

export default {
    name: 'FactBox',
    props: {
        factBoxContentId: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const toggleDisplay = function (e) {
            const factBoxContentDom = document.querySelector(
                `#${props.factBoxContentId}`
            )
            const isOpen = factBoxContentDom.classList.contains(
                'kb-fact-box__content--open'
            )
            const buttonTarget = e.currentTarget

            buttonTarget.classList[isOpen ? 'remove' : 'add'](
                'kb-fact-box__expand-button--open'
            )
            factBoxContentDom.classList[isOpen ? 'remove' : 'add'](
                'kb-fact-box__content--open'
            )
            factBoxContentDom.classList[isOpen ? 'add' : 'remove'](
                'kb-fact-box__content--closed'
            )
            e.currentTarget.setAttribute(
                'aria-expanded',
                isOpen ? 'false' : 'true'
            )

            const element = e.currentTarget.parentElement.querySelector('h3')
            if (isOpen === true) {
                element.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }

            factBoxContentDom.querySelectorAll('a').forEach((a) => {
                if (isOpen) {
                    a.setAttribute('tabindex', -1)
                } else {
                    a.removeAttribute('tabindex')
                }
            })
        }

        onMounted(() => {
            const factBoxDom = document.querySelector(
                `#${props.factBoxContentId}`
            )

            // The 'dictionaryWordMounted' event triggers when a dictionary word highlight is mounted,
            // to hide the highlight word until the FactBox is opened
            factBoxDom.addEventListener('dictionaryWordMounted', (e) => {
                const dictionaryWordHighlight = e.target
                const containingParent = dictionaryWordHighlight.parentElement
                const paragraph = document.createElement('p')
                // e.detail is the payload of the event, and in this case contains the dictionary word that has been highlighted
                paragraph.innerText = e.detail
                paragraph.classList.add(
                    'kb-fact-box__content__dictionary-word-text'
                )

                containingParent.insertBefore(
                    paragraph,
                    dictionaryWordHighlight
                )
            })

            factBoxDom.classList.add('kb-fact-box__content--closed')
        })

        return {
            toggleDisplay
        }
    }
}
